<template>
  <div class="text-center">
    <v-card flat class="mt-2 mb-2">
      <v-card-title>Paciente</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4" sm="12" xs="12">
            <soi-input :name="'Nome Completo'" :label="'Nome Completo *'" v-model="paciente.nomeCompleto" :rules="{ required: true }"
              :placeholder="'Nome Completo'" :disabled="disabled"></soi-input>
          </v-col>
          <v-col cols="12" md="4" sm="12" xs="12">
            <soi-input :name="'CPF'" :label="cpfObrigatorio ? 'Número do CPF *' : 'Número do CPF'"
              v-model="paciente.cpf" :disabled="disabled" :rules="cpfRules" :placeholder="'000.000.000-00'"
              :mask="masks.cpf">
            </soi-input>
          </v-col>
          <v-col cols="12" md="4" sm="12" xs="12">
            <soi-input :name="'RG'" :label="'Número do RG'" v-model="paciente.rg" :placeholder="'MG-8.321.654'"
              :disabled="disabled"></soi-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" sm="12" xs="12" class="d-flex align-center">
            <soi-input
              :name="'Nome Social'"
              :label="'Nome Social'"
              v-model="paciente.nomeSocial"
              :placeholder="'Nome Social'"
              :disabled="disabled"
              class="flex-grow-1"
            ></soi-input>
            <v-checkbox
              class="ml-4 mt-0"
              :disabled="paciente.nomeSocial.length < 2"
              @input="limparCheckboxNomeSocial"
              label="Utilizar nome social como principal"
              v-model="paciente.usarNomeSocialComoPrincipal"
            />
          </v-col>
          <v-col cols="12" md="6" sm="12" xs="12" class="d-flex align-center">
            <template v-if="mostrarNumeroProntuario">

              <soi-input :name="'Número do Prontuário'" :label="'Número do Prontuário'" v-model="paciente.numeroProntuario"
                  :placeholder="'Número do Prontuário'" :disabled="disabled" class="flex-grow-1" :mask="masks.numeroProntuario"></soi-input>
              <v-tooltip bottom class="d-flex align-center">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  class="ml-2"
                  v-bind="attrs"
                  v-on="on"
                  style="cursor:pointer;"
                >mdi-information-outline</v-icon>
              </template>
              <span>
                Se apagar o que há no campo e salvar o registro do paciente sem o número de prontuário, o processo será irreversível.
              </span>
            </v-tooltip>
            </template>
              </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3" sm="12" xs="12">
            <soi-input :name="'Data de Nascimento'" :label="'Data de Nascimento *'" :disabled="disabled"
              :rules="{ required: true, data_nascimento: true }" v-model="paciente.dataNascimento" type="date"></soi-input>
          </v-col>
          <v-col cols="12" md="3" sm="12" xs="12">
            <soi-input :name="'Idade'" :label="'Idade'" v-model="idade" disabled :placeholder="'Idade'">
            </soi-input>
          </v-col>
          <v-col cols="12" md="6" sm="12" xs="12">
            <soi-input :name="'Nome do pai'" :label="'Nome do pai'" v-model="paciente.nomePai"
              :placeholder="'Nome do pai'" :disabled="disabled"></soi-input>
          </v-col>
          <v-col cols="12" md="6" sm="12" xs="12">
            <soi-input :name="'Nome da mãe'" :label="'Nome da mãe'" v-model="paciente.nomeMae"
              :placeholder="'Nome da mãe'" :disabled="disabled"></soi-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3" sm="12" xs="12">
            <soi-select :label="'Sexo *'" :name="'Sexo'" :items="enumSexo" v-model="paciente.sexo" :disabled="disabled" :rules="{ required: true }"></soi-select>
          </v-col>
          <v-col cols="12" md="3" sm="12" xs="12">
            <soi-select :label="'Estado Civil'" :items="enumEstadoCivil" v-model="paciente.estadoCivil"
              :disabled="disabled"></soi-select>
          </v-col>
          <v-col cols="12" md="3" sm="12" xs="12">
            <soi-select :label="'Escolaridade'" :items="enumEscolaridade" v-model="paciente.escolaridade"
              :disabled="disabled"></soi-select>
          </v-col>
          <v-col cols="12" md="3" sm="12" xs="12">
            <soi-select :label="'Raça'" :items="enumRaca" v-model="paciente.raca" :disabled="disabled"></soi-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Vue from 'vue';
import Pacientes from '../../models/pacientes/Pacientes';
import {
  Sexo, Escolaridade, EstadoCivil, Raca,
} from '../../models/Enums';
import MaskHelper from '../../helpers/MaskHelper';
import DateHelper from '../../helpers/DateHelper';
import { mask } from 'vue-the-mask';

export default Vue.component('soi-dados-padrao-paciente', {
  props: {
    value: {
      type: Pacientes,
      default: () => new Pacientes(),
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    cpfObrigatorio: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    cpfRules() {
      return {
        required: this.cpfObrigatorio,
        min: 14,
        cpf: 'cpf',
      };
    },
  },

  data() {
    return {
      enumSexo: Sexo,
      enumEscolaridade: Escolaridade,
      enumEstadoCivil: EstadoCivil,
      enumRaca: Raca,
      paciente: new Pacientes(),
      masks: MaskHelper,
      idade: '',
      mostrarNumeroProntuario: true,
    };
  },

  methods: {
    limparCheckboxNomeSocial() {
      if (this.paciente.nomeSocial.length < 2) {
        this.paciente.usarNomeSocialComoPrincipal = false;
      }
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(novoValor) {
        this.paciente = novoValor;
        this.idade = DateHelper.calculaIdadePorExtenso(novoValor.dataNascimento);
        this.limparCheckboxNomeSocial();
        this.mostrarNumeroProntuario = !!novoValor.numeroProntuario || this.$parent.visualizar === false;
      },
    },
    'paciente.dataNascimento': {
      handler(novaDataNascimento) {
        this.idade = novaDataNascimento ? DateHelper.calculaIdadePorExtenso(novaDataNascimento) : '';
      },
    },
    'paciente.nomeSocial': {
      handler() {
        this.limparCheckboxNomeSocial();
      },
    },
  },

  mounted() {
    this.paciente = this.value;
    this.idade = DateHelper.calculaIdadePorExtenso(this.paciente.dataNascimento);
    this.limparCheckboxNomeSocial();
  },
});

</script>
<style>
.v-icon.ml-2 {
  align-self: center;
}
</style>
